// Quiz-mode calls beyond the shared v1 client. Question reporting goes to the legacy /api/quiz/report, which only
// accepts legacy question ids (qv1-/qv2-/43-char): a v1 "q_..." id is answered with INVALID_REPORT until the server maps it.
import type { Call } from './call'

export interface QuestionBookmark { kind: string; targetId: string; active: boolean; updatedAt: string }

export interface QuestionReportInput {
  questionId: string
  revision?: number
  type?: '答案' | '解析' | '题干' | '选项' | '章节' | '内容过期' | '其他'
  detail?: string
  clientRequestId?: string
  context?: Record<string, string>
}

export function createQuizModesApi(call: Call) {
  return {
    reportQuestion: (input: QuestionReportInput) => call<{ ok: true; reportId: string }>({ method: 'POST', path: '/api/quiz/report', body: input }),
    /** Ids of the questions the signed-in account currently has bookmarked. */
    bookmarkedQuestionIds: async (): Promise<string[]> => {
      const { bookmarks } = await call<{ bookmarks: QuestionBookmark[] }>({ method: 'GET', path: '/api/v1/learning/bookmarks' })
      return bookmarks.filter(b => b.kind === 'question' && b.active).map(b => b.targetId)
    },
  }
}
